import React from 'react'
import { Box } from '@mui/material';
import MainchatConTainer from '../../containers/mainchat/MainchatContainer'

const MainchatViewPage = () => {
  return (
    <Box sx={{ flexGrow: 1, width: '100%', minWidth: 0, minHeight: 0, display: 'flex' }}>
      <MainchatConTainer />
    </Box>
  );
}

export default MainchatViewPage
